var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngle90(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.459 400H364.35C358.031 356.705 343.51 316.045 322.33 279.662L281.229 304.322C298.051 333.387 309.59 365.738 315.459 400ZM263.623 277.566L304.932 252.781C283.434 222.813 257.186 196.564 227.217 175.066L202.432 216.375C225.781 233.604 246.395 254.217 263.623 277.566ZM424 432H48V56C48 42.75 37.25 32 24 32S0 42.75 0 56V456C0 469.25 10.75 480 24 480H424C437.25 480 448 469.25 448 456S437.25 432 424 432ZM200.34 157.672C163.957 136.49 123.295 121.969 80 115.65V164.541C114.26 170.41 146.613 181.949 175.68 198.773L200.34 157.672Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle90);
export default __webpack_public_path__ + "static/media/angle-90.1038beaa4788125c539c50c5c3dbc091.svg";
export { ForwardRef as ReactComponent };